var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useReducer } from 'react';
var defaults = {
    state: {},
    dispatch: function () { }
};
var Context = React.createContext(defaults);
export var buildStateProvider = function () {
    var states = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        states[_i] = arguments[_i];
    }
    var dispatchTable = {};
    var mergedState = {};
    var providedState;
    states.forEach(function (chunk) {
        var _a;
        chunk.events.forEach(function (event) {
            if (dispatchTable[event] === undefined) {
                dispatchTable[event] = [];
            }
            dispatchTable[event].push({
                callback: chunk.update,
                stateKey: chunk.stateFieldName
            });
        });
        if (mergedState[chunk.stateFieldName] !== undefined) {
            throw "buildStateProvider: Duplicate stateFieldName=" + chunk.stateFieldName + " defined in list of StateChunks";
        }
        mergedState = __assign(__assign({}, mergedState), (_a = {}, _a[chunk.stateFieldName] = chunk.data, _a));
    });
    providedState = {
        reducer: function (currentState, action) {
            var contexts = dispatchTable[action.type];
            if (!contexts) {
                return currentState;
            }
            var newState = __assign({}, currentState);
            contexts.forEach(function (ctx) {
                newState[ctx.stateKey] = ctx.callback(action.type, currentState[ctx.stateKey], { data: action.payload });
            });
            return newState;
        },
        state: mergedState
    };
    var StateProvider = function (props) {
        var children = props.children;
        var _a = __read(useReducer(providedState.reducer, providedState.state), 2), state = _a[0], dispatch = _a[1];
        return React.createElement(Context.Provider, { value: { state: state, dispatch: dispatch } }, children || null);
    };
    StateProvider.displayName = 'StateProvider';
    return StateProvider;
};
export var useProvidedState = function () {
    var _a = React.useContext(Context), state = _a.state, dispatch = _a.dispatch;
    return [state, dispatch];
};
//# sourceMappingURL=provided-state-context.js.map